/* global app, moment, _ */
/* global getHours, insertString, formatInvitationLinks */
/* global infoData, params */

"use strict";

app.controller('MainController', ['$scope', 'dataShare', '$location', '$http', '$window', '$routeParams', '$translate', function ($scope, dataShare, $location, $http, $window, $routeParams, $translate) {
    $scope.loop = [];
    $scope.loop.hasData = false;
    
    $scope.booked = [];
    $scope.bookfail = [];
    $scope.orderInfo = {};
    $scope.date = moment().startOf('day').add(1, 'days');
    $scope.orderInfo.Time = '';
    $scope.orderInfo.Discount = false;
    $scope.orderInfo.People = 0;
    $scope.orderInfo.ParentsAttending = 0;
    $scope.empty = true;
    $scope.orderInfo.deposit = false;
    $scope.orderInfo.TotalPrice = 0;
    $scope.orderInfo.TotalPriceWT = 0;
    $scope.orderInfo.TotalPriceDisc = 0;
    $scope.orderInfo.TotalPriceDiscWT = 0;
    $scope.orderInfo.Comment = '';
    $scope.orderInfo.addonsSum = 0;
    $scope.orderInfo.addonsSumWT = 0;
    $scope.orderInfo.Schedules = [];
    $scope.orderInfo.GymID = params.GymID;
    $scope.orderInfo.NameSpace = params.NameSpace;
    $scope.fail = 'Something went wrong with your registration.';
    $scope.infoData = infoData;
    $scope.logo = infoData.Logo;
    $scope.Bank = infoData.Settings.Bank;
    $scope.Cash = infoData.Settings.Cash;
    $scope.BankSingleVisit = infoData.Settings.BankSingleVisit;
    $scope.CashSingleVisit = infoData.Settings.CashSingleVisit;
    $scope.BankText = infoData.Settings.BankText;
    $scope.CashText = infoData.Settings.CashText;
    $scope.MembershipPayment = infoData.Settings.MembershipPayment;
    $scope.MembershipPaymentText = infoData.Settings.MembershipPaymentText;
    $scope.orderInfo.Earnest = infoData.Settings.Earnest;
    $scope.Currency = infoData.Currency;
    $scope.SubscriptionName = infoData.SubscriptionName;
    $scope.PhoneNumber = infoData.PhoneNumber;
    $scope.OnlineBookingTaxText = infoData.Settings.OnlineBookingTaxText;
    $scope.orderSent = false;
    $scope.PictureSingleSessions = infoData.Settings.PictureSingleSessions;
    $scope.TextSingleSessions = infoData.Settings.TextSingleSessions;
    $scope.PictureGroupSessions = infoData.Settings.PictureGroupSessions;
    $scope.TextGroupSessions = infoData.Settings.TextGroupSessions;
    $scope.PictureGroupChildrenSessions = infoData.Settings.PictureGroupChildrenSessions;
    $scope.TextGroupChildrenSessions = infoData.Settings.TextGroupChildrenSessions;
    $scope.LinkWebsite = infoData.Settings.LinkWebsite;
    $scope.LinkWebsiteTranslation = infoData.Settings.LinkWebsiteTranslation;
    $scope.Language = infoData.Country;
    $scope.PaySafeCard = infoData.PaySafeCard;
    $scope.EPay = infoData.EPay;
    $scope.PaySafeApiKeyFrontEnd = infoData.PaySafeApiKeyFrontEnd;
    $scope.CommBank = infoData.CommBank;
    $scope.CommBankPublicApiKey = infoData.CommBankPublicApiKey;
    $scope.CommBankHostedPayments = infoData.CommBankHostedPayments;
    $scope.Enviroment = infoData.Environment;
    $scope.reArenged = infoData.Settings.RegistrationLastStep;
    $scope.TelephoneNumberOptional = infoData.Settings.TelephoneNumberOptional;
    $scope.ShowCapacitySingleVisits = infoData.Settings.ShowCapacitySingleVisits;
    $scope.BirthdateSingleVisits = infoData.Settings.BirthdateSingleVisits;
    $scope.showFullPrice = infoData.Settings.ShowFullPrices;
    $scope.stripePublishKey = infoData.StripePublishKey;
    $scope.currencyCode = infoData.CurrencyCode;
    console.log(infoData);

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }else if ($scope.Language.indexOf('pt') > -1) {
        $translate.use('pt')
    }else if ($scope.Language.indexOf('it') > -1) {
        $translate.use('it')
    }else if ($scope.Language.indexOf('ro') > -1) {
        $translate.use('ro')
    }else if ($scope.Language.indexOf('lt') > -1) {
        $translate.use('lt')
    }else if ($scope.Language.indexOf('id') > -1) {
        $translate.use('id')
    }else if ($scope.Language.indexOf('de') > -1) {
        $translate.use('de')
    }
    else {
        $translate.use('en')
    }

    if (infoData.Settings.GeneralConditionsLink != null && infoData.Settings.GeneralConditionsLink != '') {
        $scope.terms = infoData.Settings.GeneralConditionsLink;
    }
    if (infoData.Country.indexOf('enu') > -1 || infoData.Country.indexOf('ius') > -1) {
        $scope.usTime = true;
        $scope.dateFormat = 'MM.DD.YYYY';
        $scope.timeFormat = 'hh:mm a'; // used when parsing times from the backend
        $scope.timePrintFormat = 'hh:mm a';
        $scope.dateTimeFormat = 'MM-DD-YYYY hh:mm a';
    }
    else {
        $scope.usTime = false;
        $scope.dateFormat = 'DD.MM.YYYY';
        $scope.timeFormat = 'HH:mm'; // used when parsing times from the backend
        $scope.timePrintFormat = 'HH:mm [h]';
        $scope.dateTimeFormat = 'DD.MM.YYYY HH:mm [h]';
    }

    $scope.AdditionalInformationLink = infoData.Settings.AdditionalInformationLink;
    $scope.FacilityRulesLink = infoData.Settings.FacilityRulesLink;
    $scope.onlinePayment = infoData.Settings.OnlinePayment;
    $scope.OnlinePaymentSingleVisit = infoData.Settings.OnlinePaymentSingleVisit;
    $scope.onlyEarnest = infoData.Settings.OnlyEarnest;
    $scope.InvitationLink = formatInvitationLinks(infoData.Settings.InvitationLink);
    $scope.Parents = infoData.Settings.Parents;
    $scope.BookingOpenAfter = infoData.Settings.BookingOpenAfter;
    $scope.PartyBookingOpenAfter = infoData.Settings.PartyBookingOpenAfter;

    $scope.WarningText = infoData.Settings.WarningText;
    $scope.WaiverLink = infoData.Settings.WaiverLink;
    $scope.WaiverWarningText = infoData.Settings.WaiverWarningText;
    $scope.WarningTextPayment = infoData.Settings.WarningTextPayment;
    $scope.WarningTextPaymentVisits = infoData.Settings.WarningTextPaymentVisits;
    $scope.AdditionalInfoAboutSessions = infoData.Settings.AdditionalInfoAboutSessions;
    $scope.LinkAdditionalInfoAboutSessions = infoData.Settings.LinkAdditionalInfoAboutSessions;
    $scope.orderInfo.OnlineBookingWhatToWear = '';


    function orderInfoReset(){
        $scope.orderInfo = {};
        $scope.orderInfo.Time = '';
        $scope.orderInfo.Discount = false;
        $scope.orderInfo.People = 0;
        $scope.orderInfo.ParentsAttending = 0;
        $scope.orderInfo.deposit = false;
        $scope.orderInfo.TotalPrice = 0;
        $scope.orderInfo.TotalPriceWT = 0;
        $scope.orderInfo.TotalPriceDisc = 0;
        $scope.orderInfo.TotalPriceDiscWT = 0;
        $scope.orderInfo.Comment = '';
        $scope.orderInfo.addonsSum = 0;
        $scope.orderInfo.addonsSumWT = 0;
        $scope.orderInfo.Areas = [];
        $scope.orderInfo.Schedules = [];
        $scope.orderInfo.GymID = params.GymID;
        $scope.orderInfo.NameSpace = params.NameSpace;
        $scope.orderInfo.Earnest = infoData.Settings.Earnest;
        $scope.orderInfo.OnlineBookingWhatToWear = '';
    }

    $scope.checkOrderInfo = function(){
        if ( $scope.orderInfo.Schedules.length > 0 || $scope.orderInfo.Areas.length > 0 ){

        }else{
            $scope.refreshPage()
        }
    }

    $scope.loading = true;
    $scope.sendOrderFail = false;

    $scope.getTotal = function () {
        $scope.orderInfo.TotalPriceWithoutTax = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].PriceWithoutTax = $scope.booked[i].PriceWithoutTax - ($scope.booked[i].PriceWithoutTax / 100 * $scope.booked[i].Discount);
            }
            $scope.orderInfo.TotalPriceWithoutTax += $scope.booked[i].people * $scope.booked[i].PriceWithoutTax;
        }
        $scope.orderInfo.TotalPriceWithoutTax += $scope.orderInfo.addonsSum;
    };

    $scope.imageHolder = 'http://localhost:20691/Frontend/onlinebooking/dist/images/events.png';

    $scope.getTotalWithTax = function () {
        $scope.orderInfo.TotalPrice = 0;

        for (var i = 0; i < $scope.booked.length; i++) {
            if ($scope.booked[i].Discount != undefined && $scope.booked[i].Discount > 0) {
                $scope.booked[i].TotalPrice = $scope.booked[i].TotalPrice - ($scope.booked[i].TotalPrice / 100 * $scope.booked[i].Discount);
            }
            $scope.orderInfo.TotalPrice += $scope.booked[i].people * $scope.booked[i].TotalPrice;
        }
        $scope.orderInfo.TotalPrice += $scope.orderInfo.addonsSumWT
        $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPrice
    };

    $scope.orderPayed = false;
    $scope.backInfo = [];
    $scope.sendOrderInfo = function (data, url) {
        $scope.sendOrderFail = false;
        $scope.orderSent = true;

        var justDate = moment($scope.orderInfo.StartDate).startOf('day');

        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');

        if (data.Schedules.length > 0) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax;
        } else {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPrice;
        }

        if ($scope.orderInfo.DiscountPromoCode > 0) {
            $scope.orderInfo.TotalPriceWithoutTax = $scope.orderInfo.TotalPriceWithoutTax - ($scope.orderInfo.TotalPriceWithoutTax / 100 * $scope.orderInfo.DiscountPromoCode);
            // $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice - ($scope.orderInfo.TotalPrice / 100 * $scope.orderInfo.DiscountPromoCode);
            // $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPriceWT - ($scope.orderInfo.TotalPriceWT / 100 * $scope.orderInfo.DiscountPromoCode);
        }

        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay)
            dateTime = dateTime.add(-1, 'hours');
        $scope.orderInfo.StartDate = moment(dateTime).format($scope.dateTimeFormat).toString();

        if (data.deposit === false && $scope.onlyEarnest !== true)
            data.Earnest = 0;
        else
            data.Earnest = infoData.Settings.Earnest;


        if ( !$scope.orderPayed ) {
            $http({
                method: 'POST',
                url: url,
                data: data
            }).then(function (d) {
                $scope.orderPayed = true;
                if (d.data === '' || d.data.toString().indexOf('Error') !== -1) {
                    $scope.fail = d.data;
                    // orderInfoReset();
                    $window.location.href = $scope.params + '#booking-failed/0';
                } else if (typeof d.data === 'string' || d.data instanceof String) {
                    if ($scope.orderInfo.PaymentType == "4" || $scope.orderInfo.PaymentType == "6") {
                        $('.payment-status .error-msg').addClass('show').append('<p>' + d.data + '</p>');
                        $scope.orderSent = false;
                    }
                    else {
                        // orderInfoReset();
                        $window.location.href = d.data;
                    }
                }
                else {
                    $scope.backInfo = d.data;
                    $scope.backInfo.Schedules = d.data.Schedules;

                    if ($scope.backInfo.Schedules && $scope.backInfo.Schedules.length > 0)
                        $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
                    else {
                        $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
                    }

                    for (var key in $scope.backInfo.Schedules) {
                        $scope.backInfo.Schedules[key].DateEnd = moment($scope.backInfo.Schedules[key].DateEnd).format($scope.dateTimeFormat);
                        $scope.backInfo.Schedules[key].DateStart = moment($scope.backInfo.Schedules[key].Date).format($scope.dateTimeFormat);
                    }
                    $scope.backInfo.DateStart = moment(d.data.DateStart).format($scope.dateTimeFormat);
                    $scope.backInfo.DateEnd = moment(d.data.DateEnd).format($scope.dateTimeFormat);



                    /*var paypal = {};
                    paypal.OrderID = $scope.backInfo.OrderID = d.data.OrderID;
                    if (($scope.backInfo.Schedules.length == 0) && $scope.onlyEarnest == true || $scope.orderInfo.deposit) {
                        paypal.TotalPrice = infoData.Settings.Earnest;
                    } else{
                        paypal.TotalPrice = d.data.TotalPrice;
                    }
                    paypal.NameSpace = params.NameSpace;
                    paypal.GymID = params.GymID;
                    paypal.TotalPriceWithoutTax = d.data.TotalPriceWithoutTax;*/

                    /*if ($scope.orderInfo.PaymentType == 1) {
                        $scope.sendPaypal(paypal);
                    } else*/
                    // orderInfoReset();
                    if ($scope.backInfo.Schedules.length > 0) {
                        $window.location.href = $scope.params + '#/booking-completed/';
                    } else {
                        $window.location.href = $scope.params + '#/complete-booking/';
                    }
                }
                $('.info.blocks-checkout').removeClass('loading');
            }, function () {
                $scope.sendOrderFail = true;
                $scope.orderSent = false;
                $scope.loading = false;
                // var url = $scope.params + '#/booking-failed/0';
                // $window.location.href = url;
            });
        }

    };

    /*$scope.sendPaypal = function (d) {
        $http({
            method: 'POST',
            url: '/onlinebooking/sendpayment/',
            data: d
        }).then(function (data) {
            $window.location.href = data.data;
        }, function () {

        })
    }*/

    $scope.params = "/onlinebooking/index?GymID=" + $scope.orderInfo.GymID + "&NameSpace=" + $scope.orderInfo.NameSpace;

    if ($routeParams.id == 1) {
        $scope.fail = "Your request was canceled successfully";
    } else if ($routeParams.id == 0) {
        $scope.fail = 'Something went wrong with your registration.';
    }

    $scope.reset = function () {

        if ( $('.complete-booking').length ){
            $window.location.href = $scope.params;
        }else{
            Swal.fire({
                title: 'Are you sure you want to continue?',
                text: "Your order info will be lost!",
                // type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!'
            })
            .then(function(result) {
                if (result.value) {
                    $window.location.href = $scope.params;
                }
            })
        }
    };

    $scope.hasDataRedirect = function () {
        if ($scope.loop.hasData == false) {
            $window.location.href = $scope.params;
        }
    };

    $scope.refreshPage = function () {
        $window.location.href = $scope.params;
    }
}]);

app.controller('RegisterController', ['$scope', '$http', '$window', '$translate', function ($scope, $http, $window, $translate) {
    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.text = 'me@example.com';
    $scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    var currentYear = new Date().getFullYear();
    $scope.dateYears = [];
    startYear = 1900;

    while (startYear <= currentYear) {
        $scope.dateYears.push(startYear++);
    }

    function daysInMonth(m, y) { // m is 0 indexed: 0-11
        switch (m) {
            case 1:
                return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
            case 8: case 3: case 5: case 10:
                return 30;
            default:
                return 31
        }
    }


    function isValid(d, m, y) {
        return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
    }

    $scope.readyToSendMain = true;

    $scope.sendData = function (t) {
        $scope.error = false;
        if ($scope.orderInfo.EmergencyName1) {
            $scope.orderInfo.EmergencyName = $scope.orderInfo.EmergencyName1 + " " + $scope.orderInfo.EmergencyName2;
        }

        if ($('#clientBirthdayDay').length) {
            if (isValid($scope.clientBirthdayDay, $scope.clientBirthdayMonth - 1, $scope.clientBirthdayYear)) {
                $scope.readyToSendMain = true;
                $scope.orderInfo.BirthDate = $scope.clientBirthdayMonth + '-' + $scope.clientBirthdayDay + '-' + $scope.clientBirthdayYear;
            } else {
                $scope.readyToSendMain = false;
            }
        }

        if ($scope.readyToSendMain == true) {
            $http.post('/OnlineBooking/AddClient', $scope.orderInfo)
                 .then(function successCallback(response) {
                     if (parseInt(response.data == 0) || response.data == null || response.data < 0) {
                         $scope.error = true;
                         $scope.userForm.$invalid = false;
                         $window.location.reload();

                     } else if (response.data > 0) {

                         $scope.orderInfo.ClientID = parseInt(response.data);
                         $scope.error = false;

                         if (t == 'visits') {

                             if ($scope.reArenged == true) {
                                 $window.location.href = $scope.params + '#/finish/';
                             } else {
                                 $window.location.href = $scope.params + '#/visits/';
                             }
                         } else {
                             if ($scope.reArenged == true) {
                                 $window.location.href = $scope.params + '#/final/';
                             } else {
                                 $window.location.href = $scope.params + '#/select-package/';
                             }
                         }

                         $scope.loop.hasData = true;
                     }
                 }, function (d) {
                     $scope.userForm.$invalid = false;
                     $scope.error = true;
                     $window.location.reload();
                 });
        }
    };

}]);

app.controller('AllVisitController', ['$scope', 'getServicesAndProducts', '$window', '$translate', function ($scope, getServicesAndProducts, $window, $translate) {

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    getServicesAndProducts.async().then(function (d) {
        $scope.visits = d.SingleVisitsMain;
        $scope.visits = $scope.visits.concat(d.SingleVisitsSub);

        for (var i = 0; i < $scope.visits.length; i++) {

            if ($scope.visits[i].PriceWithoutTax == 0 || $scope.visits[i].PriceWithoutTax == null)
                $scope.visits[i].PriceWithoutTax = $scope.visits[i].TotalPrice;
        }

        $scope.loading = false;
    });


    $scope.sendPackage = function (id) {
        $window.location.href = $scope.params + '#/select-visit-date/' + id;
    };

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }

}]);

app.controller('VisitsController', ['$scope', '$filter', '$routeParams', '$window', '$http', '$timeout', '$q', 'getServicesAndProducts', 'dataShare', 'Backend', '$translate',
function ($scope, $filter, $routeParams, $window, $http, $timeout, $q, getServicesAndProducts, dataShare, Backend, $translate) {

    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.orderInfo.id = $routeParams.id;
    $scope.orderInfo.Areas = [];
    $scope.orderInfo.Time = '';
    $scope.orderInfo.PriceWithoutTax = '';
    $scope.orderInfo.VisitName = '';
    $scope.package = [];
    $scope.package.offDays = 'all';
    $scope.visits = [];
    $scope.ready = false;
    $scope.loading = true;
    $scope.hoursText = '';
    $scope.curHours = [];
    $scope.visitHours = [];
    $scope.haveAddons = false;

    // if ( $scope.reArenged == true && $scope.orderInfo.Schedules.length > 0) {
    //     $scope.finalSchedule = $scope.orderInfo.Schedules;
    //     $scope.lastV = $scope.finalSchedule[$scope.finalSchedule.length - 1];
    //     $scope.lastId = $scope.lastV.VisitID;

    //     $scope.removeByAttr($scope.orderInfo.Schedules, 'VisitID', $scope.lastId);
    //     $scope.removeByAttr($scope.booked, 'VisitID', $scope.lastId);
    // }

    //$scope.BookingOpenAfter = 8;

    $scope.minBookableTime = moment().add($scope.BookingOpenAfter, 'hours');
    $scope.minDate = $scope.minBookableTime;

    getServicesAndProducts.async().then(function (d) {
        $scope.visits = d.SingleVisitsMain;
        $scope.visits = $scope.visits.concat(d.SingleVisitsSub);
        console.log(d);
        if (d.SingleVisitsAddons != undefined && d.SingleVisitsAddons.length > 0)
            $scope.haveAddons = true;

        for (var i = 0; i < $scope.visits.length; i++) {

            //$scope.visits[i].Description = insertString($scope.visits[i].Description, '<P>');

            if ($scope.visits[i].VisitDefinitionID == $scope.orderInfo.id)
                $scope.visit = $scope.visits[i];

            if ($scope.visits[i].PriceWithoutTax == 0 || $scope.visits[i].PriceWithoutTax == null)
                $scope.visits[i].PriceWithoutTax = $scope.visits[i].TotalPrice;
        }

        if ($scope.visit.OnlineBookingDaysOfWeek)
            $scope.visit.offDays = $scope.visit.OnlineBookingDaysOfWeek.split(',').map(function (offDay) { return parseInt(offDay, 10); });//[1, 3, 4];
        else
            $scope.visit.offDays = 'all';

        $scope.getTotal();

        $scope.visits.sort(function (a, b) {
            return a.OnlineBookingSortingNumber - b.OnlineBookingSortingNumber;
        });

        var minHour = $scope.minBookableTime.format("HH") + ":00";
        $scope.hoursText = $scope.visit.OnlineBookingHoursText;
        $scope.defHours = getHours($scope.hoursText);

        var todayHoursArray = $scope.hoursText.split(",");
        var todayPassHours = _.remove(todayHoursArray, function (n) {
            return n < minHour;
        });

        //if (!todayHoursArray.length) {
        //    $scope.minDate = moment($scope.minDate).add(1, 'days');
        //    $scope.hours = $scope.defHours;
        //} else {
        //    $scope.todayHours = getHoursArr(todayHoursArray);
        //    $scope.hours = $scope.todayHours;
        //}

        $scope.vHours = $scope.visit.OnlineBookingHours;

        var today = new Date();
        var d = new Date(2011, 11, 11);

        $.each($scope.vHours, function (index, value) {
            var self = $(this);
            var hours = [];

            $.each(self[0].Hours, function (index, value) {
                var innerSelf = $(this);
                var newDateObj = moment(d).add(innerSelf[0].Time.TotalMinutes, 'm').format('HH:mm');

                hours.push(newDateObj);
            });

            var oned = { day: self[0].DayOfWeek, hours: [hours] }
            $scope.visitHours.push(oned);
        });

        $scope.todayHours = getHoursArr(todayHoursArray);

        if (moment($scope.date).format('MMM Do YY') == moment($scope.minDate._d).format('MMM Do YY')) {
            $scope.hours = $scope.todayHours;
        } else {
            $scope.hours = $scope.defHours;
        }

        $scope.loading = false;
    });

    var n = 0;

    var toSchedules = function (bookInfo) {
        $scope.orderInfo.Schedules = [];
        $scope.bookedInfo = $scope.booked.map(function (bookedItem) {
            n++;

            var sessionID = bookedItem.VisitID + bookedItem.VisitName + n;

            return {
                VisitID: bookedItem.VisitID,
                VisitName: bookedItem.VisitName,
                PeopleAttending: bookedItem.people,
                Date: moment(bookedItem.Date).toISOString(),
                Price: bookedItem.TotalPrice,
                PriceWithoutTax: bookedItem.PriceWithoutTax,
                Duration: bookedItem.Duration,
                DateLocal: bookedItem.DateLocal,
                TaxIDs: bookedItem.TaxIDs,
                SessionID: sessionID,
                UniqueID: bookedItem.VisitID + bookedItem.DateLocal
            };
        });


        $scope.orderInfo.Schedules = $scope.bookedInfo;
    };

    $scope.getTotal = function () {
        $scope.orderInfo.TotalPrice = $scope.orderInfo.People * $scope.visit.PriceWithoutTax;
        $scope.orderInfo.TotalPriceDisc = $scope.orderInfo.TotalPrice;

        $scope.orderInfo.TotalPriceWT = $scope.orderInfo.People * $scope.visit.TotalPrice;
        $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;

        if ($scope.visit.OnlineBookingMinPeopleForDiscount > 0) {
            if ($scope.orderInfo.People >= $scope.visit.OnlineBookingMinPeopleForDiscount) {

                $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice - ($scope.orderInfo.TotalPrice * ($scope.visit.OnlineBookingDiscount / 100));
                $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPriceWT - ($scope.orderInfo.TotalPriceWT * ($scope.visit.OnlineBookingDiscount / 100));
                $scope.orderInfo.Discount = true;

                $scope.orderInfo.PriceWithTax = $scope.visit.PriceWithoutTax - ($scope.visit.PriceWithoutTax * ($scope.visit.OnlineBookingDiscount / 100));
            } else {
                $scope.orderInfo.Discount = false;
                $scope.orderInfo.PriceWithTax = $scope.visit.PriceWithoutTax;
            }
        }
        else {
            $scope.orderInfo.Discount = false;
            $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice;
            $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPriceWT;
        }

        $scope.selected = 0;

        var date = $scope.date;
        if ($scope.orderInfo.People > 0) {
            $scope.ready = false;
            $scope.checkConflict(date);
        }

        $('.hours .hour.selected').removeClass('selected');
        $scope.selectedIndex = 99;
    };

    //setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1500;  //time in ms, 5 second for example
    var $input = $('.people-change-input');

    //on keyup, start the countdown
    $input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    //on keydown, clear the countdown 
    $input.on('keydown', function () {
        clearTimeout(typingTimer);
    });

    //user is "finished typing," do something
    function doneTyping() {
        $scope.getTotal();
    }

    $scope.$watch('date', function (date) {

        var numberDay = moment(date).format('e');
        var ree = $.grep($scope.visitHours, function (e) { return e.day == numberDay; });
        if (ree != undefined && ree.length > 0) {
            var hours = ree[0].hours[0];
            $scope.realHours = [];
            for (i = 0; i < ree[0].hours[0].length; i++) {

                var justDate = moment(date).startOf('day');
                var justTime = moment(ree[0].hours[0][i], $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                if (moment(dateTime).isAfter($scope.minBookableTime)) {
                    $scope.realHours.push(ree[0].hours[0][i]);
                }
            }
            if ($scope.todayHours == undefined && $scope.defHours == undefined) {
                return;
            }

            $scope.ready = false;
            $scope.checkConflict(date);
        }

        $('.hours .hour.selected').removeClass('selected');
        $scope.selectedIndex = 99;
    });

    $scope.checkConflict = function (b) {
        $scope.noHours = false;

        $scope.ccData = {};
        $scope.loading = true;

        $scope.ccData.VisitId = $scope.orderInfo.id;
        $scope.ccData.StartDate = b;
        if ($scope.orderInfo.People < 1)
            $scope.ccData.People = 1;
        else
            $scope.ccData.People = $scope.orderInfo.People;
        $scope.ccData.NameSpace = $scope.orderInfo.NameSpace;
        $scope.ccData.GymID = $scope.orderInfo.GymID;
        $scope.ccData.IsBirthday = false;
        $scope.orderInfo.Date = b;

        if ($scope.realHours) {
            $scope.ccData.StartDate = $scope.realHours.map(function (h) {
                var justDate = moment($scope.date).startOf('day');
                var justTime = moment(h, $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
                if (isDstChangeDay)
                    dateTime = dateTime.add(1, 'hours');

                return dateTime.toISOString();
            });

            Backend.checkConflictAsync($scope.ccData).then(function success(results) {
                $scope.curHours = _.map(results.data, function (hourData) {
                    return {
                        isConflict: hourData.MaxPeople > 0,
                        areas: hourData.Areas,
                        value: moment(hourData.StartDate).format($scope.timeFormat),
                        slotsleft: hourData.SlotsLeft
                    };
                });

                if ($scope.curHours.length == 0) {
                    $scope.noHours = true;
                }

                var hoursResult = $.grep($scope.curHours, function (e) { return e.isConflict == false; });
                if (hoursResult.length == 1) {
                    var emptyValue = hoursResult[0].value;
                    var emptyIndex = $('.hours .hour:contains("' + emptyValue + '")').parent('div').index() - 1;

                    if (emptyIndex >= 0) {
                        $scope.selectedIndex = emptyIndex;
                        $scope.compare($scope.selectedIndex);
                    }
                }

                $scope.loading = false;
            });

            $scope.compare();
        }
    };


    $scope.bookVisit = function (item) {
        var dateLocal = moment(new Date(item.Date)).format($scope.dateTimeFormat);
        //if ($scope.booked.length == 1)
        //    $scope.booked = [];
        $scope.bookedItem = { VisitID: item.id, VisitName: $scope.visit.VisitName, UniqueID: item.id + dateLocal, people: item.People, Date: item.Date, Price: $scope.visit.PriceCurrent, TotalPrice: $scope.visit.PriceCurrent, PriceWithoutTax: $scope.visit.PriceWithoutTax, Duration: $scope.visit.Duration, DateLocal: dateLocal, TaxIDs: $scope.visit.TaxIDs, Tax: $scope.visit.TaxPercent, OnlineBookingPictureLink: $scope.visit.OnlineBookingPictureLink, Description: $scope.visit.Description }

        var result = $.grep($scope.booked, function (e) { return e.UniqueID == $scope.bookedItem.UniqueID; });
        if (result.length > 0) {

        } else {
            $scope.booked.push($scope.bookedItem);
        }
    }

    $scope.compare = function ($index) {

        if ($index == undefined)
            return;
        $scope.selectedIndex = $index;

        var SelectedItem = $scope.curHours[$index];
        if (SelectedItem != undefined) {
            if (SelectedItem.isConflict == true) {
                $scope.ready = false;
            } else {
                $scope.orderInfo.Time = $scope.realHours[$index];
                $scope.hours = $scope.realHours;
                $scope.orderInfo.Areas = $scope.curHours[$index].areas;

                var maxPeople = $scope.orderInfo.Areas[0].MaxPeople;

                if ($scope.orderInfo.People > 0 && $scope.orderInfo.Time != '' && $scope.orderInfo.People <= maxPeople) {
                    $scope.ready = true;
                }
                else {
                    $scope.ready = false;
                }
            }
        }
    }

    $scope.setDate = function (date) {
        var justDate = moment($scope.date).startOf('day');
        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var hour = justTime.hours();
        var minutes = justTime.minutes();
        var dateTime = moment(date);
        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay)
            dateTime = dateTime.add(hour + 1, 'hours').add(minutes, 'minutes');
        else
            dateTime = dateTime.add(hour, 'hours').add(minutes, 'minutes');
        $scope.orderInfo.Date = moment(dateTime);
        $scope.orderInfo.StartDate = moment(dateTime);


        // if( $scope.orderInfo.id )
        $scope.bookVisit($scope.orderInfo);
        toSchedules();
    }

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }

}]);

app.controller('PackagesController', ['$scope', 'getServicesAndProducts', '$window', '$translate', function ($scope, getServicesAndProducts, $window, $translate) {

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    getServicesAndProducts.async().then(function (d) {
        $scope.loading = false;
        $scope.packages = d.MainServices;
        console.log(d);


        for (var i = 0; i < $scope.packages.length; i++) {
            if ($scope.packages[i].Description != null) {
                $scope.packages[i].Description = insertString($scope.packages[i].Description, '<P>');
            }
            if ($scope.packages[i].OnlineBookingMinPeopleForDiscount != 0)
                $scope.packages[i].OnlineBookingMinPeopleForDiscount++;

            if ($scope.packages[i].PriceWithoutTax == 0 || $scope.packages[i].PriceWithoutTax == null)
                $scope.packages[i].PriceWithoutTax = $scope.packages[i].TotalPrice;
        }

        $scope.packages.sort(function (a, b) {
            return a.OnlineBookingSortingNumber - b.OnlineBookingSortingNumber;
        });
    });

    $scope.sendPackage = function (id) {
        $window.location.href = $scope.params + '#/select-date/' + id;
    };

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }

}]);

app.controller('CalendarController', ['$scope', '$filter', '$routeParams', '$http', '$timeout', '$q', 'getServicesAndProducts', 'dataShare', 'Backend', '$translate',
function ($scope, $filter, $routeParams, $http, $timeout, $q, getServicesAndProducts, dataShare, Backend, $translate) {

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.orderInfo.id = $routeParams.id;
    $scope.ready = false;
    $scope.loading = true;
    $scope.limitReached = 0;
    $scope.hoursText = '';
    if ($scope.PartyBookingOpenAfter > 0)
        $scope.minDate = moment().add($scope.PartyBookingOpenAfter, 'hours');
    else
        $scope.minDate = moment();
    $scope.curHours = [];
    $scope.visitHours = [];
    $scope.orderInfo.Areas = [];

    getServicesAndProducts.async().then(function (d) {
        $scope.packages = d.MainServices;

        for (var i = 0; i < $scope.packages.length; i++) {
            if ($scope.packages[i].Description != null) {
                $scope.packages[i].Description = insertString($scope.packages[i].Description, '<P>');
            }

            if ($scope.packages[i].OnlineBookingMinPeopleForDiscount != 0)
                $scope.packages[i].OnlineBookingMinPeopleForDiscount++;

            if ($scope.packages[i].VisitDefinitionID == $scope.orderInfo.id)
                $scope.package = $scope.packages[i];

            if ($scope.packages[i].PriceWithoutTax == 0 || $scope.packages[i].PriceWithoutTax == null)
                $scope.packages[i].PriceWithoutTax = $scope.packages[i].TotalPrice;
        }
        if ($scope.package.OnlineBookingDaysOfWeek)
            $scope.package.offDays = $scope.package.OnlineBookingDaysOfWeek.split(',').map(function (offDay) { return parseInt(offDay, 10); });//[1, 3, 4];
        else
            $scope.package.offDays = 'all';

        $scope.vHours = $scope.package.OnlineBookingHours;

        var today = new Date();
        var d = new Date(2011, 11, 11);

        $.each($scope.vHours, function (index, value) {
            var self = $(this);
            var hours = [];

            $.each(self[0].Hours, function (index, value) {
                var innerSelf = $(this);
                var newDateObj = moment(d).add(innerSelf[0].Time.TotalMinutes, 'm').format('HH:mm');

                hours.push(newDateObj);
            });

            var oned = { day: self[0].DayOfWeek, hours: [hours] }
            $scope.visitHours.push(oned);
        });

        $scope.getTotal();

        $scope.orderInfo.OnlineBookingMinPeopleForEvent = $scope.package.OnlineBookingMinPeopleForEvent;
        $scope.hoursText = $scope.package.OnlineBookingHoursText;
        $scope.hours = getHours($scope.hoursText);
        $scope.loading = false;

        $scope.orderInfo.OnlineBookingWhatToWear = $scope.package.OnlineBookingWhatToWear;
    });

    $scope.getTotal = function () {
        if ($scope.package.MinimalPackagePriceByPeople > 0) {
            $scope.orderInfo.TotalPrice = $scope.package.MinimalPackagePriceByPeopleWithoutTax;
            $scope.orderInfo.TotalPriceDisc = $scope.orderInfo.TotalPrice;

            $scope.orderInfo.TotalPriceWT = $scope.package.MinimalPackagePriceByPeople;
            $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;
            if ($scope.orderInfo.People > $scope.package.MinimalPackagePeople) {
                $scope.orderInfo.TotalPrice += ($scope.orderInfo.People - $scope.package.MinimalPackagePeople) * $scope.package.PriceWithoutTax;
                $scope.orderInfo.TotalPriceDisc += ($scope.orderInfo.People - $scope.package.MinimalPackagePeople) * $scope.package.PriceWithoutTax;

                $scope.orderInfo.TotalPriceWT += ($scope.orderInfo.People - $scope.package.MinimalPackagePeople) * $scope.package.TotalPrice;
                $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;
            }
        }
        else {
            $scope.orderInfo.TotalPrice = $scope.orderInfo.People * $scope.package.PriceWithoutTax;
            $scope.orderInfo.TotalPriceDisc = $scope.orderInfo.TotalPrice;

            $scope.orderInfo.TotalPriceWT = $scope.orderInfo.People * $scope.package.TotalPrice;
            $scope.orderInfo.TotalPriceDiscWT = $scope.orderInfo.TotalPriceWT;
        }
        if ($scope.package.OnlineBookingMinPeopleForDiscount > 0) {
            if ($scope.orderInfo.People >= $scope.package.OnlineBookingMinPeopleForDiscount) {
                if ($scope.package.MinimalPackagePriceByPeople > 0) {
                    if ($scope.package.OnlineBookingMinPeopleForDiscount <= $scope.orderInfo.People) {
                        var peopleToDiscount = $scope.orderInfo.People - $scope.package.OnlineBookingMinPeopleForDiscount + 1;
                        $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice - ($scope.package.PriceWithoutTax * peopleToDiscount * ($scope.package.OnlineBookingDiscount / 100));
                        $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPrice - ($scope.package.PriceWithoutTax * peopleToDiscount * ($scope.package.OnlineBookingDiscount / 100));
                        $scope.orderInfo.Discount = true;
                    }
                }
                else {
                    $scope.orderInfo.TotalPrice = $scope.orderInfo.TotalPrice - ($scope.orderInfo.TotalPrice * ($scope.package.OnlineBookingDiscount / 100));
                    $scope.orderInfo.TotalPriceWT = $scope.orderInfo.TotalPriceWT - ($scope.orderInfo.TotalPriceWT * ($scope.package.OnlineBookingDiscount / 100));
                    $scope.orderInfo.Discount = true;
                }
            } else {
                $scope.orderInfo.Discount = false;
            }
        }
        $scope.parentsAllowed = parseInt($scope.orderInfo.People);
        $scope.selected = 0;

        $('.hours .hour.selected').removeClass('selected');
        $scope.selectedIndex = 99;
        $scope.checkDateConflict();
        $scope.Compare();
    };

    //setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1500;  //time in ms, 5 second for example
    var $input = $('.people-change-input');

    //on keyup, start the countdown
    $input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    //on keydown, clear the countdown 
    $input.on('keydown', function () {
        $scope.ready = false;
        clearTimeout(typingTimer);
    });

    //user is "finished typing," do something
    function doneTyping() {
        $scope.getTotal();
    }

    $scope.$watch('date', function (date) {
        //if ($scope.orderInfo.People > 0)
        var numberDay = moment(date).format('e');
        if ($scope.visitHours != undefined)
            var ree = $.grep($scope.visitHours, function (e) { return e.day == numberDay; });
        if (ree != undefined && ree.length > 0)
            var hours = ree[0].hours[0];

        var finalHours = [];
        if (hours != undefined)
            for (var i = 0; i < hours.length; i++) {
                var justDate = moment(date).startOf('day');
                var justTime = moment(hours[i], $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                if (dateTime >= $scope.minDate)
                    finalHours.push(hours[i]);
            }
        $scope.realHours = finalHours;
        $scope.checkDateConflict();
    });

    $scope.checkDateConflict = function () {
        var dateTime = moment($scope.date).startOf('day');
        $scope.loading = true;
        $scope.noHours = false;

        $scope.checkConflictData = {};
        $scope.checkConflictData.NameSpace = $scope.orderInfo.NameSpace;
        $scope.checkConflictData.GymID = $scope.orderInfo.GymID
        $scope.checkConflictData.ParentsAttending = parseInt($scope.orderInfo.ParentsAttending, 10)
        $scope.checkConflictData.People = parseInt($scope.orderInfo.People, 10);
        $scope.checkConflictData.VisitId = parseInt($scope.orderInfo.id);
        $scope.orderInfo.StartDate = dateTime;
        $scope.checkConflictData.IsBirthday = true;
        $scope.checkConflictData.StartDate = {};

        if ($scope.realHours) {

            $scope.checkConflictData.StartDate = $scope.realHours.map(function (h) {
                var justDate = moment($scope.date).startOf('day');
                var justTime = moment(h, $scope.timeFormat);
                var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');
                var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
                if (isDstChangeDay)
                    dateTime = dateTime.add(1, 'hours');

                return dateTime.toISOString();
            });

            Backend.checkConflictAsync($scope.checkConflictData).then(function success(results) {
                $scope.curHours = _.map(results.data, function (hourData) {
                    return {
                        isConflict: hourData.MaxPeople > 0,
                        areas: hourData.Areas,
                        value: moment(hourData.StartDate).format($scope.timeFormat),
                    };
                });

                if ($scope.curHours.length == 0) {
                    $scope.noHours = true;
                }

                $scope.loading = false;

                var hoursResult = $.grep($scope.curHours, function (e) { return e.isConflict == false; });
                if (hoursResult.length == 1) {
                    var emptyValue = hoursResult[0].value;
                    var emptyIndex = $('.hours .hour:contains("' + emptyValue + '")').parent('div').index() - 1;

                    if (emptyIndex >= 0) {
                        $scope.selectedIndex = emptyIndex;
                        $scope.isSelected($scope.selectedIndex);
                    }
                }
            });
        }
    };

    $scope.parentAlert = false;
    $scope.parentsAllowed = parseInt($scope.orderInfo.People);
    $scope.Compare = function () {
        if (infoData.Settings.Parents) {
            $scope.orderInfo.ParentsAttending = parseInt($scope.orderInfo.ParentsAttending, 10);
            $scope.orderInfo.People = parseInt($scope.orderInfo.People, 10);

            if ($scope.orderInfo.ParentsAttending > 0 && $scope.orderInfo.People > 0 && $scope.orderInfo.ParentsAttending > $scope.orderInfo.People) {
                $scope.parentAlert = false;

            } else {
                $scope.parentAlert = true;
            }

            if ($scope.orderInfo.People > 0 && $scope.orderInfo.People >= $scope.orderInfo.OnlineBookingMinPeopleForEvent && $scope.orderInfo.Time !== '' && $scope.orderInfo.ParentsAttending > 0 && $scope.parentAlert === true && $scope.selectedIndex !== -1 && $scope.loading != true)
                $scope.ready = true;
            else
                $scope.ready = false;
        } else {
            $scope.orderInfo.People = parseInt($scope.orderInfo.People, 10);

            if ($scope.orderInfo.People > 0 && $scope.orderInfo.People >= $scope.orderInfo.OnlineBookingMinPeopleForEvent && $scope.orderInfo.Time !== '' && $scope.selectedIndex !== -1 && $scope.loading != true)
                $scope.ready = true;
            else
                $scope.ready = false;

        }
    };

    $scope.Compare();

    $scope.count = 0;

    $scope.selectedIndex = -1;
    $scope.isSelected = function ($index) {
        $scope.orderInfo.Time = $scope.curHours[$index].value
        $scope.selectedIndex = $index;
        $scope.orderInfo.Areas = $scope.curHours[$index].areas;
        $scope.orderInfo.VisitID = $scope.orderInfo.id;
        $scope.Compare();
    };

    $scope.$watch('date', function () {
        $scope.selectedIndex = -1;
        $scope.ready = false;
    });

    $scope.setDate = function (date) {
        var justDate = moment($scope.date).startOf('day');
        var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
        var hour = justTime.hours();
        var minutes = justTime.minutes();
        var dateTime = moment(date);
        var isDstChangeDay = moment(justDate, "DD.MM.YYYY").isDST() !== moment(justDate, "DD.MM.YYYY").add(1, "day").isDST();
        if (isDstChangeDay)
            dateTime = dateTime.add(hour + 1, 'hours').add(minutes, 'minutes');
        else
            dateTime = dateTime.add(hour, 'hours').add(minutes, 'minutes');
        $scope.orderInfo.StartDate = moment(dateTime);
    }

    dataShare.addInfo($scope.orderInfo);

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }

}]);

app.controller('AddonsController', ['$scope', 'getServicesAndProducts', '$window', '$routeParams', 'dataShare', '$translate', function ($scope, getServicesAndProducts, $window, $routeParams, dataShare, $translate) {
    $scope.checkOrderInfo();

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    var data = dataShare.getData();

    $scope.orderInfo = data.orderInfo;
    $scope.id = $routeParams.id;
    $scope.full = false;
    $scope.Price = $scope.orderInfo.TotalPrice;

    $scope.Date = moment($scope.orderInfo.StartDate).format($scope.dateFormat);
    $scope.partyDate = moment($scope.orderInfo.StartDate).format($scope.dateFormat);
    $scope.Time = $scope.orderInfo.Time;

    $scope.prods = data.products
    $scope.adds = data.addons;

    getServicesAndProducts.async().then(function (d) {
        $scope.packages = d.MainServices;
        $scope.items = d.SubServices;
        $scope.products = d.OnlineProducts;

        for (var i = 0; i < $scope.packages.length; i++) {
            if ($scope.packages[i].Description != null) {
                $scope.packages[i].Description = insertString($scope.packages[i].Description, '<P>');
            }

            if ($scope.packages[i].OnlineBookingMinPeopleForDiscount != 0)
                $scope.packages[i].OnlineBookingMinPeopleForDiscount++;

            if ($scope.packages[i].VisitDefinitionID == $scope.id)
                $scope.package = $scope.packages[i];

            if ($scope.packages[i].PriceWithoutTax == 0 || $scope.packages[i].PriceWithoutTax == null)
                $scope.packages[i].PriceWithoutTax = $scope.packages[i].TotalPrice;
        }

        for (var i = 0; i < $scope.items.length; i++) {
            $scope.items[i].Amount = 0;
            for (var j = 0; j < $scope.adds.length; j++) {
                if ($scope.items[i].VisitDefinitionID == $scope.adds[j].VisitDefinitionID && $scope.adds[j].added == true)
                    $scope.items[i].added = true;
            }

            if ($scope.items[i].PriceWithoutTax == 0 || $scope.items[i].PriceWithoutTax == null)
                $scope.items[i].PriceWithoutTax = $scope.items[i].TotalPrice;
        }

        for (var i = 0; i < $scope.products.length; i++) {
            $scope.products[i].Amount = 0;
            for (var j = 0; j < $scope.prods.length; j++) {
                if ($scope.products[i].ProductID == $scope.prods[j].ProductID && $scope.prods[j].added == true)
                    $scope.products[i].added = true;
            }


            if ($scope.products[i].PriceWithoutTax == 0 || $scope.products[i].PriceWithoutTax == null)
                $scope.products[i].PriceWithoutTax = $scope.products[i].TotalPrice
        }
    });

    $scope.saveAdd = function (i) {
        $scope.i = i;

        if ($scope.i.Amount > 0) {
            $scope.i.Total = $scope.i.Amount * $scope.i.PriceWithoutTax;
            $scope.i.TotalWT = $scope.i.Amount * $scope.i.TotalPrice;


            $scope.i.msg = false;
            $scope.i.added = true;

            dataShare.addAddon(i);
            updateAddonsSum();
        } else {
            $scope.i.msg = true;
            $scope.i.added = false;
        }
    }

    $scope.saveProduct = function (i) {
        $scope.i = i;
        $scope.i.PriceWithoutTax = $scope.i.PriceWithoutTax;
        $scope.i.VisitName = $scope.i.ProductName;
        $scope.i.VisitDefinitionID = $scope.i.ProductID;

        if ($scope.i.Amount > 0) {
            if ($scope.i.PriceWithoutTax > 0) {
                $scope.i.Total = $scope.i.Amount * $scope.i.PriceWithoutTax;
            }
            else
                $scope.i.Total = 0;

            if ($scope.i.PriceSell > 0) {
                $scope.i.TotalWT = $scope.i.Amount * $scope.i.PriceSell;
            }
            else
                $scope.i.TotalWT = 0;

            $scope.i.msg = false;
            $scope.i.added = true;

            dataShare.addProduct(i);
            updateAddonsSum();
        } else {
            $scope.i.msg = true;
            $scope.i.added = false;
        }
    }

    $scope.deleteAdd = function (k) {
        var key;
        for (key in $scope.adds) {
            if ($scope.adds[key].VisitDefinitionID == k)
                $scope.adds.splice(key, 1);
        }
        for (key in $scope.items) {
            if ($scope.items[key].VisitDefinitionID == k)
                $scope.items[key].added = false;

        }

        for (key in $scope.prods) {
            if ($scope.prods[key].VisitDefinitionID == k)
                $scope.prods.splice(key, 1);
        }

        for (key in $scope.products) {
            if ($scope.products[key].ProductID == k)
                $scope.products[key].added = false;
        }

        updateAddonsSum();
    };

    var updateAddonsSum = function () {
        $scope.addonsSum = 0;
        $scope.addonsSumWT = 0;
        $scope.Price = 0;
        var i;
        var hasItems = false;
        for (i = 0; i < $scope.adds.length; i++) {
            if ($scope.adds[i].PriceWithoutTax > 0)
                $scope.addonsSum += $scope.adds[i].PriceWithoutTax * $scope.adds[i].Amount;
            if ($scope.adds[i].TotalPrice > 0)
                $scope.addonsSumWT += $scope.adds[i].TotalPrice * $scope.adds[i].Amount;
            hasItems = true;
        }

        for (i = 0; i < $scope.prods.length; i++) {
            if ($scope.prods[i].PriceWithoutTax > 0)
                $scope.addonsSum += $scope.prods[i].PriceWithoutTax * $scope.prods[i].Amount;
            if ($scope.prods[i].PriceSell > 0)
                $scope.addonsSumWT += $scope.prods[i].PriceSell * $scope.prods[i].Amount;
            hasItems = true;
        }

        if ($scope.addonsSum > 0 || hasItems == true) {
            $scope.full = true;
        } else {
            $scope.full = false;
        }

        $scope.Price = $scope.orderInfo.TotalPrice + $scope.addonsSum;

        $scope.orderInfo.addonsSum = $scope.addonsSum;
        $scope.orderInfo.addonsSumWT = $scope.addonsSumWT;
    };
    updateAddonsSum();

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }

}]);

app.controller('AddonsControllerVisits', ['$scope', 'getServicesAndProducts', '$window', '$routeParams', 'dataShare', '$translate', function ($scope, getServicesAndProducts, $window, $routeParams, dataShare, $translate) {

    $scope.checkOrderInfo();

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.id = $routeParams.id;
    $scope.full = false;
    $scope.Price = $scope.orderInfo.TotalPrice;

    $scope.visit = $scope.booked[0];
    $scope.Date = moment($scope.booked[0].Date).format($scope.dateFormat);
    $scope.partyDate = moment($scope.booked[0].Date).format($scope.dateFormat);
    var data = dataShare.getData();
    $scope.adds = data.addons;

    getServicesAndProducts.async().then(function (d) {
        $scope.items = d.SingleVisitsAddons;

        for (var i = 0; i < $scope.items.length; i++) {
            $scope.items[i].Amount = 0;
            for (var j = 0; j < $scope.adds.length; j++) {
                if ($scope.items[i].VisitDefinitionID == $scope.adds[j].VisitDefinitionID && $scope.adds[j].added == true)
                    $scope.items[i].added = true;
            }

            if ($scope.items[i].PriceWithoutTax == 0 || $scope.items[i].PriceWithoutTax == null)
                $scope.items[i].PriceWithoutTax = $scope.items[i].TotalPrice;
        }
    });

    $scope.saveAdd = function (i) {
        $scope.i = i;

        if ($scope.i.Amount > 0) {
            $scope.i.Total = $scope.i.Amount * $scope.i.PriceWithoutTax;
            $scope.i.TotalWT = $scope.i.Amount * $scope.i.TotalPrice;

            $scope.i.msg = false;
            $scope.i.added = true;

            dataShare.addAddon(i);
            updateAddonsSum();
        } else {
            $scope.i.msg = true;
            $scope.i.added = false;
        }
    }

    $scope.deleteAdd = function (k) {
        var key;
        for (key in $scope.adds) {
            if ($scope.adds[key].VisitDefinitionID == k)
                $scope.adds.splice(key, 1);
        }
        for (key in $scope.items) {
            if ($scope.items[key].VisitDefinitionID == k)
                $scope.items[key].added = false;

        }

        for (key in $scope.prods) {
            if ($scope.prods[key].VisitDefinitionID == k)
                $scope.prods.splice(key, 1);
        }

        for (key in $scope.products) {
            if ($scope.products[key].ProductID == k)
                $scope.products[key].added = false;
        }

        updateAddonsSum();
    };

    var updateAddonsSum = function () {
        $scope.addonsSum = 0;
        $scope.addonsSumWT = 0;
        $scope.Price = 0;
        var i;
        for (i = 0; i < $scope.adds.length; i++) {
            $scope.addonsSum += $scope.adds[i].PriceWithoutTax * $scope.adds[i].Amount;
            $scope.addonsSumWT += $scope.adds[i].TotalPrice * $scope.adds[i].Amount;
        }

        if ($scope.addonsSum > 0) {
            $scope.full = true;
        } else {
            $scope.full = false;
        }

        $scope.Price = $scope.orderInfo.TotalPrice + $scope.addonsSum;

        $scope.orderInfo.addonsSum = $scope.addonsSum;
        $scope.orderInfo.addonsSumWT = $scope.addonsSumWT;
    };
    updateAddonsSum();

    if ($scope.reArenged != true) {
        $scope.hasDataRedirect();
    }
}]);

///Used for Party Reservation
app.controller('FinalController', ['$scope', 'dataShare', '$translate', '$http', function ($scope, dataShare, $translate, $http) {
    if ( window.location.href.indexOf('final') > 1 ){
        $scope.checkOrderInfo();
    }
    window.scrollTo(0, 0);
    var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    var url = '/onlinebooking/SaveBirthDay/';

    currentYear += 20;
    $scope.years = [];

    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    var data = dataShare.getData();
    $scope.final = [];
    $scope.paymentPageText = infoData.Settings.PaymentPageText;

    $scope.final.Price = $scope.orderInfo.TotalPrice + $scope.orderInfo.addonsSum;
    $scope.final.PriceWT = $scope.orderInfo.TotalPriceWT + $scope.orderInfo.addonsSumWT;
    $scope.final.PriceDisc = $scope.orderInfo.TotalPriceDisc + $scope.orderInfo.addonsSum;
    $scope.final.PriceDiscWT = $scope.orderInfo.TotalPriceDiscWT + $scope.orderInfo.addonsSumWT;

    $scope.final.Tax = $scope.final.PriceWT - $scope.final.Price;
    $scope.final.TaxDisc = $scope.final.PriceDiscWT - $scope.final.PriceDisc;

    var justDate = moment($scope.orderInfo.StartDate).startOf('day');
    var justTime = moment($scope.orderInfo.Time, $scope.timeFormat);
    var dateTime = moment(justDate).add(justTime.hours(), 'hours').add(justTime.minutes(), 'minutes');


    $scope.partyDate = moment(dateTime).format($scope.dateTimeFormat);

    $scope.orderInfo.ChildName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;
    $scope.orderInfo.ParentName = $scope.orderInfo.EmergencyName;
    $scope.orderInfo.Language = 1;
    $scope.orderInfo.ExtraProducts = data.products;
    $scope.orderInfo.ExtraVisits = data.addons;
    $scope.PaySafeCard = infoData.PaySafeCard;
    $scope.PaySafeApiKeyFrontEnd = infoData.PaySafeApiKeyFrontEnd;
    $scope.CommBank = infoData.CommBank;
    $scope.CommBankPublicApiKey = infoData.CommBankPublicApiKey;
    $scope.paySafeInit = false;
    $scope.ZIP = '';
    $scope.Przelewy24 = infoData.Przelewy24;
    $scope.orderInfo.PromoCode = '';
    $scope.orderInfo.DiscountPromoCode = 0;
    $scope.promocodeFalse = false;
    $scope.promocodeTrue = false;

    $scope.changePromoStatus = function () {
        $scope.promocodeTrue = false;
    }

    $scope.changePromoCode = function () {

        $scope.orderInfo.DiscountPromoCode = 0;

        $scope.final.Price = $scope.orderInfo.TotalPrice + $scope.orderInfo.addonsSum;
        $scope.final.PriceWT = $scope.orderInfo.TotalPriceWT + $scope.orderInfo.addonsSumWT;
        $scope.final.PriceDisc = $scope.orderInfo.TotalPriceDisc + $scope.orderInfo.addonsSum;
        $scope.final.PriceDiscWT = $scope.orderInfo.TotalPriceDiscWT + $scope.orderInfo.addonsSumWT;

        $scope.promocodeFalse = false;
        $scope.promocodeTrue = false;
        if ($scope.orderInfo.PromoCode.length > 3) {
            $scope.orderInfo.Date = $scope.orderInfo.StartDate;
            $http({
                method: 'POST',
                url: '/onlinebooking/ValidatePromoCode',
                data: $scope.orderInfo
            }).success(function (data) {

                if (data.length > 0) {
                    for (i = 0; i < data.length; i++) {
                        if (data[i].VisitID == $scope.orderInfo.VisitID) {
                            $scope.orderInfo.DiscountPromoCode = data[i].Discount;
                        }
                    }
                    if ($scope.orderInfo.DiscountPromoCode > 0) {
                        $scope.final.Price = ($scope.orderInfo.TotalPrice - ($scope.orderInfo.TotalPrice / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSum;
                        $scope.final.PriceWT = ($scope.orderInfo.TotalPriceWT - ($scope.orderInfo.TotalPriceWT / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSumWT;
                        $scope.final.PriceDisc = ($scope.orderInfo.TotalPriceDisc - ($scope.orderInfo.TotalPriceDisc / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSum;
                        $scope.final.PriceDiscWT = ($scope.orderInfo.TotalPriceDiscWT - ($scope.orderInfo.TotalPriceDiscWT / 100 * $scope.orderInfo.DiscountPromoCode)) + $scope.orderInfo.addonsSumWT;

                        $scope.promocodeTrue = true;
                        $scope.promocodeFalse = false;
                    } else {
                        if (!$scope.promocodeTrue) {
                            $scope.promocodeTrue = false;
                            $scope.promocodeFalse = true;
                        }
                    }
                } else {
                    $scope.promocodeFalse = true;
                }
            }).error(function () {
            });
        }
    };


    $scope.$watch('orderInfo.PaymentType', function (v) {
        $scope.orderInfo.PaymentType = v;
        if (v == 4) {
            if (!$scope.paySafeInit) {
                if ($scope.PaySafeCard == true && $scope.PaySafeApiKeyFrontEnd != '') {
                    $scope.paySafeInit = true;
                    // Base64 encoded version the Single-use Token API key.
                    // Create the key below by concatenating the API username and password
                    // separated by a colon and Base64-encoding the result
                    var apiKey = infoData.PaySafeApiKeyFrontEnd;

                    var Enviroment = "TEST";
                    if ($scope.Enviroment == true)
                        Enviroment = "LIVE";
                    var options = {

                        // select the Paysafe test / sandbox environment
                        environment: Enviroment,

                        // set the CSS selectors to identify the payment field divs above
                        // set the placeholder text to display in these fields
                        fields: {
                            cardNumber: {
                                selector: "#cardNumber",
                                placeholder: "Card number"
                            },
                            expiryDate: {
                                selector: "#expiryDate",
                                placeholder: "Expiry date"
                            },
                            cvv: {
                                selector: "#cvv",
                                placeholder: "CVV"
                            }
                        }
                    };

                    paysafe.fields.setup(apiKey, options, function (instance, error) {
                        document.getElementById("payNow").addEventListener("click", function (event) {
                            $('.info.blocks-checkout').addClass('loading');
                            instance.tokenize(function (instance, error, result) {
                                if (error) {
                                    $('.payment-status .error-msg').addClass('show').append('<p>' + error.message + '</p>');
                                    $('.info.blocks-checkout').removeClass('loading');
                                } else {
                                    $scope.orderInfo.Token = result.token;
                                    $scope.orderInfo.Comment = $scope.svComment;
                                    $scope.sendOrderInfo($scope.orderInfo, url);
                                }
                            });
                        }, false);
                    });
                }
            }
        }
        else {
            $scope.ShowPaySafe = false;
        }

         if (v == 66) {
            /**
             * Configure hosted payments callback.
             */
            $scope.finalBankPrice = $scope.final.PriceWT.toFixed(2).split('.').join("");
            $scope.finalBankPrice = parseInt($scope.finalBankPrice);

            var hostedPayments = SimplifyCommerce.hostedPayments(
                function(response) {
                    var cardToken = response.cardToken;
                    console.log(cardToken);
                    // TODO: Pass token to the server & use Simplify's API to make a payment

                    $scope.orderInfo.Token = cardToken;
                    $scope.sendOrderInfo($scope.orderInfo, url);
                },
                {
                    scKey: infoData.CommBankPublicApiKey,
                    amount: $scope.finalBankPrice,
                    operation: 'create.token',
                }
            );
            /**
             * Handle the error response from the server call that
             * failed to make a payment from the card token.
             */
            function apiPaymentErrorHandler() {
                // re-enable the payment button, so the user can try again.
                hostedPayments.enablePayBtn();
                // TODO: Handle error
            }
        }

        if (v == 6) {
            $("#process-payment-btn").on("click", function () {
                $('.info.blocks-checkout').addClass('loading');
                $('.payment-form.cbform, .loader-container.cbform-loader').addClass('loading');
                // Disable the submit button
                $("#process-payment-btn").attr("disabled", "disabled");
                // Generate a card token & handle the response
                SimplifyCommerce.generateToken({
                    key: infoData.CommBankPublicApiKey,
                    card: {
                        number: $("#cc-number").val(),
                        cvc: $("#cc-cvc").val(),
                        expMonth: $("#cc-exp-month").val(),
                        expYear: $("#cc-exp-year").val()
                    }
                }, simplifyResponseHandler);
                // Prevent the form from submitting
                return false;
            });

            function simplifyResponseHandler(data) {
                var $paymentForm = $("#payment-form");
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // Display the errors
                        $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');
                    }
                    // Re-enable the submit button
                    $("#process-payment-btn").removeAttr("disabled");
                    $('.info.blocks-checkout').removeClass('loading');
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form.cbform .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server
                    $scope.orderInfo.Token = token;
                    $scope.sendOrderInfo($scope.orderInfo, url);
                }
                $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
            }
        }

        if (v == 7) {
            $scope.orderInfo.PaymentProvider = "paylogin";
        }
        if (v == 71) {
            $scope.orderInfo.PaymentProvider = "credit_paydirect";
        }

        if (v == 8) {

            $('.blocks-checkout .next').addClass('show-stripe-btn');
            // Create a Stripe client.
            var stripe = Stripe($scope.stripePublishKey);
            // Create an instance of Elements.
            var elements = stripe.elements();
            // Custom styling can be passed to options when creating an Element.
            // (Note that this demo uses a wider set of styles than the guide below.)
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };


            // Create an instance of the card Element.
            if ($scope.currencyCode == 'EUR') {
                var card = elements.create('card', { style: style, hidePostalCode: true });
            } else {
                var card = elements.create('card', { style: style });
            }

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            // Handle form submission.
            var form = document.getElementById('payment-form');

            $('.stripe-button').on('click', function (e) {
                e.preventDefault();
                $('.info.blocks-checkout').addClass('loading');

                stripe.createToken(card).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        $('.info.blocks-checkout').removeClass('loading');
                    } else {
                        // Send the token to your server.
                        $scope.orderInfo.Token = result.token.id;
                        $scope.sendOrderInfo($scope.orderInfo, url);
                    }
                });

            })
        } else {
            $('.blocks-checkout .next').removeClass('show-stripe-btn');
        }
    });

    $scope.$watch('e', function (v) {
        if (v == 1) {
            $scope.orderInfo.deposit = true;
        } else {
            $scope.orderInfo.deposit = false;
        }
    });

    $scope.checkValue = function (v) {
        if ($scope.req == true) {
            if (v < 100) {
                $scope.earnest = true;
            } else {
                $scope.earnest = false;
            }
        }
    };

    $scope.sendOrder = function () {
        $scope.orderInfo.Earnest = parseInt($scope.orderInfo.Earnest);
        if ($scope.orderInfo.PaymentType == 71) {
            $scope.orderInfo.PaymentType = 7;
        }

        console.log($scope.orderInfo);
        $scope.sendOrderInfo($scope.orderInfo, url);
    };



    if ($scope.orderInfo.PaymentType == 0) {
        $scope.backInfo.type = 'Cash';
        $scope.cash = true;
    } else if ($scope.orderInfo.PaymentType == 4 || $scope.orderInfo.PaymentType == 6) {
        $scope.backInfo.type = 'Card transaction';
    } else {
        $scope.bank = true;
        $scope.backInfo.type = 'Bank';
    }

    $scope.backInfo.visit = 'Birthday Booking';
    $scope.backInfo.PaidSum = 0;
    $scope.backInfo.RemainingSum = $scope.orderInfo.TotalPrice;
    $scope.hasDataRedirect();

}]);

///Used for single visit reservation
app.controller('FinishController', ['$scope', '$translate', '$window', '$http', 'dataShare', function ($scope, $translate, $window, $http, dataShare) {

    if ( window.location.href.indexOf('finish') > 1 ){
        $scope.checkOrderInfo();
    }
    window.scrollTo(0, 0);
    var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    var url = '/onlinebooking/bookvisits/';
    currentYear += 20;
    $scope.years = [];
    $scope.loading = false;

    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.data = [];
    for (b = 0; b < $scope.orderInfo.Schedules.length; b++) {
        if ($scope.orderInfo.Schedules[b].PriceOriginal != undefined) {
            $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].PriceOriginal;
            $scope.orderInfo.Schedules[b].Discount = 0;
        }
    }
    for (var b = 0; b < $scope.booked.length; b++) {
        if ($scope.booked[b].PriceWithoutTaxOriginal != undefined && $scope.booked[b].TotalPriceOriginal != undefined) {
            $scope.booked[b].Discount = 0;
            $scope.booked[b].PriceWithoutTax = $scope.booked[b].PriceWithoutTaxOriginal;
            $scope.booked[b].TotalPrice = $scope.booked[b].TotalPriceOriginal;
        }
    }
    $scope.getTotal();
    $scope.getTotalWithTax();
    $scope.orderInfo.UserID = -1;
    $scope.visits = true;
    $scope.finalSchedule = $scope.orderInfo.Schedules;
    $scope.lastV = $scope.finalSchedule[$scope.finalSchedule.length - 1];
    $scope.lastId = $scope.lastV.VisitID;
    $scope.paymentPageText = infoData.Settings.PaymentPageText;
    $scope.GiftCardsSingleVisitsPayment = infoData.Settings.GiftCardsSingleVisitsPayment;
    $scope.orderInfo.TotalPriceWOTax = $scope.orderInfo.TotalPriceWithoutTax;
    $scope.orderInfo.Tax = $scope.orderInfo.TotalPrice - $scope.orderInfo.TotalPriceWithoutTax;
    $scope.PaySafeCard = infoData.PaySafeCard;
    $scope.PaySafeApiKeyFrontEnd = infoData.PaySafeApiKeyFrontEnd;
    $scope.CommBank = infoData.CommBank;
    $scope.CommBankPublicApiKey = infoData.CommBankPublicApiKey;
    $scope.paySafeInit = false;
    $scope.ZIP = '';
    $scope.Przelewy24 = infoData.Przelewy24;

    var data = dataShare.getData();

    $scope.orderInfo.Addons = data.addons;

    $scope.orderInfo.Valid = true;
    $scope.orderInfo.PromoCode = '';
    $scope.promocodeFalse = false;
    $scope.changePromoStatus = function () {
        $scope.promocodeTrue = false;
    }

    $scope.changePromoCode = function () {

        for (b = 0; b < $scope.orderInfo.Schedules.length; b++) {
            $scope.orderInfo.Schedules[b].Discount = 0;
            $scope.orderInfo.Schedules[b].PriceOriginal = $scope.orderInfo.Schedules[b].PriceWithoutTax;
            $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].PriceOriginal;
        }
        for (var b = 0; b < $scope.booked.length; b++) {
            $scope.booked[b].Discount = 0;
            $scope.booked[b].PriceWithoutTaxOriginal = $scope.booked[b].Price;
            $scope.booked[b].PriceWithoutTax = $scope.booked[b].Price;
            $scope.booked[b].TotalPrice = $scope.booked[b].Price;
        }

        $scope.getTotal();
        $scope.getTotalWithTax();

        $scope.promocodeFalse = false;
        $scope.promocodeTrue = false;
        if ($scope.orderInfo.PromoCode.length > 3) {
            $http({
                method: 'POST',
                url: '/onlinebooking/ValidatePromoCode',
                data: $scope.orderInfo
            }).success(function (data) {

                if (data.length > 0) {
                    for (i = 0; i < data.length; i++) {
                        for (b = 0; b < $scope.orderInfo.Schedules.length; b++) {
                            if (data[i].VisitID == $scope.orderInfo.Schedules[b].VisitID) {
                                $scope.orderInfo.Schedules[b].Discount = data[i].Discount;
                                $scope.orderInfo.Schedules[b].PriceOriginal = $scope.orderInfo.Schedules[b].Price;
                                $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].Price - ($scope.orderInfo.Schedules[b].Price / 100 * data[i].Discount);
                                $scope.promocodeTrue = true;
                                $scope.promocodeFalse = false;
                            }
                            else {
                                if (!$scope.promocodeTrue) {
                                    $scope.promocodeTrue = false;
                                    $scope.promocodeFalse = true;
                                }
                            }
                        }
                        for (var b = 0; b < $scope.booked.length; b++) {
                            if (data[i].VisitID == $scope.booked[b].VisitID) {
                                $scope.booked[b].Discount = data[i].Discount;
                                $scope.booked[b].PriceWithoutTaxOriginal = $scope.booked[b].PriceWithoutTax;
                                $scope.booked[b].TotalPriceOriginal = $scope.booked[b].TotalPrice;
                                $scope.promocodeTrue = true;
                                $scope.promocodeFalse = false;
                            } else {

                                if (!$scope.promocodeTrue) {
                                    $scope.promocodeTrue = false;
                                    $scope.promocodeFalse = true;
                                }
                            }
                        }
                    }
                    $scope.getTotal();
                    $scope.getTotalWithTax();
                } else {
                    $scope.promocodeFalse = true;
                }

            }).error(function () {
            });

        }
        else {
            for (b = 0; b < $scope.orderInfo.Schedules.length; b++) {
                if ($scope.orderInfo.Schedules[b].PriceOriginal != undefined) {
                    $scope.orderInfo.Schedules[b].Price = $scope.orderInfo.Schedules[b].PriceOriginal;
                }
                $scope.getTotal();
                $scope.getTotalWithTax();
            }
        }

    };

    $scope.$watch('orderInfo.PaymentType', function (v) {
        $scope.orderInfo.PaymentType = v;
        if (v == 3 || v == 10) {
            $scope.orderInfo.Valid = false;
            return;
        }
        if (v == 4) {
            if (!$scope.paySafeInit) {
                if ($scope.PaySafeCard == true && $scope.PaySafeApiKeyFrontEnd != '') {
                    $scope.paySafeInit = true;
                    // Base64 encoded version the Single-use Token API key.
                    // Create the key below by concatenating the API username and password
                    // separated by a colon and Base64-encoding the result
                    var apiKey = infoData.PaySafeApiKeyFrontEnd;
                    var Enviroment = "TEST";
                    if ($scope.Enviroment == true)
                        Enviroment = "LIVE";
                    var options = {

                        // select the Paysafe test / sandbox environment
                        environment: Enviroment,

                        // set the CSS selectors to identify the payment field divs above
                        // set the placeholder text to display in these fields
                        fields: {
                            cardNumber: {
                                selector: "#cardNumber",
                                placeholder: "Card number"
                            },
                            expiryDate: {
                                selector: "#expiryDate",
                                placeholder: "Expiry date"
                            },
                            cvv: {
                                selector: "#cvv",
                                placeholder: "CVV"
                            }
                        }
                    };

                    paysafe.fields.setup(apiKey, options, function (instance, error) {
                        document.getElementById("payNow").addEventListener("click", function (event) {
                            $('.info.blocks-checkout').addClass('loading');
                            instance.tokenize(function (instance, error, result) {
                                if (error) {
                                    $('.payment-status .error-msg').addClass('show').append('<p>' + error.message + '</p>');
                                    $('.info.blocks-checkout').removeClass('loading');
                                } else {
                                    $scope.orderInfo.Token = result.token;
                                    $scope.orderInfo.Comment = $scope.svComment;
                                    $scope.sendOrderInfo($scope.orderInfo, url);
                                }
                            });
                        }, false);
                    });
                }
            }
        }
        else {
            $scope.ShowPaySafe = false;
        }

        if (v == 66) {
            /**
             * Configure hosted payments callback.
             */
            $scope.finalBankPrice = $scope.orderInfo.TotalPriceWT.toFixed(2).split('.').join("");
            $scope.finalBankPrice = parseInt($scope.finalBankPrice);

            var hostedPayments = SimplifyCommerce.hostedPayments(
                function(response) {
                    var cardToken = response.cardToken;
                    console.log(cardToken);
                    // TODO: Pass token to the server & use Simplify's API to make a payment

                    $scope.orderInfo.Token = cardToken;
                    $scope.sendOrderInfo($scope.orderInfo, url);
                },
                {
                    scKey: infoData.CommBankPublicApiKey,
                    amount: $scope.finalBankPrice,
                    operation: 'create.token',
                }
            );
            /**
             * Handle the error response from the server call that
             * failed to make a payment from the card token.
             */
            function apiPaymentErrorHandler() {
                // re-enable the payment button, so the user can try again.
                hostedPayments.enablePayBtn();
                // TODO: Handle error
            }
        }

        if (v == 6) {
            $("#process-payment-btn").on("click", function () {
                $('.info.blocks-checkout').addClass('loading');
                $('.payment-form.cbform, .loader-container.cbform-loader').addClass('loading');
                // Disable the submit button
                $("#process-payment-btn").attr("disabled", "disabled");
                // Generate a card token & handle the response
                SimplifyCommerce.generateToken({
                    key: infoData.CommBankPublicApiKey,
                    card: {
                        number: $("#cc-number").val(),
                        cvc: $("#cc-cvc").val(),
                        expMonth: $("#cc-exp-month").val(),
                        expYear: $("#cc-exp-year").val()
                    }
                }, simplifyResponseHandler);
                // Prevent the form from submitting
                return false;
            });

            function simplifyResponseHandler(data) {
                var $paymentForm = $("#payment-form");
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // console.log(errorList);
                        // Display the errors
                        $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');
                    }
                    // Re-enable the submit button
                    $("#process-payment-btn").removeAttr("disabled");
                    $('.info.blocks-checkout').removeClass('loading');
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form.cbform .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server

                    $scope.orderInfo.Token = token;
                    $scope.sendOrderInfo($scope.orderInfo, url);
                    // $paymentForm.get(0).submit();
                }
                $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
            }
        }

        if (v == 7) {
            $scope.orderInfo.PaymentProvider = "paylogin";
        }
        if (v == 71) {
            $scope.orderInfo.PaymentProvider = "credit_paydirect";
        }

        if (v == 8) {
            $('.blocks-checkout .next').addClass('show-stripe-btn');
            // Create a Stripe client.
            var stripe = Stripe($scope.stripePublishKey);
            // Create an instance of Elements.
            var elements = stripe.elements();
            // Custom styling can be passed to options when creating an Element.
            // (Note that this demo uses a wider set of styles than the guide below.)
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };


            // Create an instance of the card Element.
            if ($scope.currencyCode == 'EUR') {
                var card = elements.create('card', { style: style, hidePostalCode: true });
            } else {
                var card = elements.create('card', { style: style });
            }

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function (event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            // Handle form submission.
            var form = document.getElementById('payment-form');

            $('.stripe-button').on('click', function (e) {
                e.preventDefault();
                $('.info.blocks-checkout').addClass('loading');

                stripe.createToken(card).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        $('.info.blocks-checkout').removeClass('loading');
                    } else {
                        // Send the token to your server.
                        $scope.orderInfo.Token = result.token.id;
                        $scope.sendOrderInfo($scope.orderInfo, url);
                    }
                });

            })
        } else {
            $('.blocks-checkout .next').removeClass('show-stripe-btn');
        }

        $scope.orderInfo.Valid = true;
    });

    //setup before functions
    var typingTimerMembership;                //timer identifier
    var doneTypingIntervalMembership = 2000;  //time in ms, 5 second for example
    var $inputMembership = $('#membershipCardField');
    $scope.membershipCodeValid = true;

    //on keyup, start the countdown
    $inputMembership.on('keyup', function () {
      clearTimeout(typingTimerMembership);
      typingTimerMembership = setTimeout(doneTypingMembership, doneTypingIntervalMembership);
    });

    //on keydown, clear the countdown 
    $inputMembership.on('keydown', function () {
      clearTimeout(typingTimerMembership);
    });

    //user is "finished typing," do something
    function doneTypingMembership () {
      //do something

        if ( $scope.orderInfo.CardNumber == '' ) {
            $scope.membershipCodeValid = true;
        }else{
            if ($scope.orderInfo.PaymentType == 3 && $scope.orderInfo.CardNumber != '' && $scope.orderInfo.CardNumber != undefined) {
                $scope.orderInfo.Valid = false;
                $http.post('/OnlineBooking/ValidateMembership', $scope.orderInfo)
                .then(function successCallback(response) {
                    if (response.data == 'True') {
                        $scope.orderInfo.Valid = true;
                        $scope.membershipCodeValid = true;
                    } else{
                        $scope.orderInfo.Valid = false;
                        $scope.membershipCodeValid = false;
                    }
                })
            }
        }
        $scope.$apply();
    }

    //setup before functions
    var typingTimerGiftCard;                //timer identifier
    var doneTypingIntervalGiftCard = 2000;  //time in ms, 5 second for example
    var $inputGiftCard = $('#giftCodeCardField');
    $scope.giftCodeValid = true;

    //on keyup, start the countdown
    $inputGiftCard.on('keyup', function () {
      clearTimeout(typingTimerGiftCard);
      typingTimerGiftCard = setTimeout(doneTypingGiftCard, doneTypingIntervalGiftCard);
    });

    //on keydown, clear the countdown 
    $inputGiftCard.on('keydown', function () {
      clearTimeout(typingTimerGiftCard);
    });

    //user is "finished typing," do something
    function doneTypingGiftCard () {
      //do something

        if ( $scope.orderInfo.GiftCardCode == '' ) {
            $scope.giftCodeValid = true;
        }else{
            if ($scope.orderInfo.PaymentType == 10 && $scope.orderInfo.GiftCardCode != '' && $scope.orderInfo.GiftCardCode != undefined) {
                $scope.orderInfo.Valid = true;
                var dataObject = {
                    Code: $scope.orderInfo.GiftCardCode,
                    Amount: $scope.orderInfo.TotalPrice,
                    GymID: infoData.GymID,
                    Namespace: infoData.NameSpace
                }

                $http.post('/OnlineBooking/ValidateGiftCode', dataObject)
                .then(function successCallback(response) {
                    if (response.data == 'true') {
                        $scope.orderInfo.Valid = true;
                        $scope.giftCodeValid = true;
                    } else{
                        $scope.orderInfo.Valid = false;
                        $scope.giftCodeValid = false;
                    }
                })
            }
        }
        $scope.$apply();
    }


    $scope.sendOrder = function () {
        $scope.orderInfo.Comment = $scope.svComment;
        if ($scope.orderInfo.PaymentType == 71) {
            $scope.orderInfo.PaymentType = 7;
        }

        console.log($scope.orderInfo);
        $scope.sendOrderInfo($scope.orderInfo, url);
    };

    $scope.removeVisit = function (visit) {
        $scope.removeByAttr($scope.booked, 'UniqueID', visit.UniqueID)
        $scope.removeByAttr($scope.orderInfo.Schedules, 'UniqueID', visit.UniqueID)
        $scope.getTotal();
        $scope.getTotalWithTax();
        $scope.finalSchedule = $scope.orderInfo.Schedules;
        $scope.lastV = $scope.finalSchedule[$scope.finalSchedule.length - 1];
        $scope.lastId = $scope.lastV.VisitID;
        $scope.paymentPageText = infoData.Settings.PaymentPageText;
        $scope.orderInfo.TotalPriceWOTax = $scope.orderInfo.TotalPriceWithoutTax + $scope.orderInfo.addonsSum;
        $scope.orderInfo.Tax = $scope.orderInfo.TotalPrice - $scope.orderInfo.TotalPriceWithoutTax;
    };

    $scope.backFinish = function () {
        if ($scope.reArenged == true) {
            $window.location.href = $scope.params + '#/register-visits/';
        } else {
            $scope.removeByAttr($scope.orderInfo.Schedules, 'VisitID', $scope.lastId);
            $scope.removeByAttr($scope.booked, 'VisitID', $scope.lastId);

            $window.location.href = $scope.params + '#/select-visit-date/' + $scope.lastId;
        }
    };


    if ($scope.orderInfo.PaymentType == 0) {
        $scope.backInfo.type = 'Cash';
        $scope.cash = true;
    } else if ($scope.orderInfo.PaymentType == 4 || $scope.orderInfo.PaymentType == 6) {
        $scope.backInfo.type = 'Card transaction';
    }else if ($scope.orderInfo.PaymentType == 10){
        $scope.backInfo.type = 'Gift Card';
    } else {
        $scope.bank = true;
        $scope.backInfo.type = 'Bank';
    }


    $scope.backInfo.visit = 'Session Booking';

    $scope.backInfo.ParentName = $scope.orderInfo.FirstName + " " + $scope.orderInfo.LastName;

    $scope.backInfo.PaidSum = 0;
    $scope.backInfo.RemainingSum = $scope.orderInfo.TotalPrice;
    $scope.hasDataRedirect();

    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

}]);

app.controller('CompleteController', ['$scope', '$http', '$routeParams', '$translate', function ($scope, $http, $routeParams, $translate) {
    // $scope.checkOrderInfo();
    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('cat') > -1 || $scope.Language.indexOf('esm') > -1) {
        $translate.use('es')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    $scope.backInfo = [];
    $scope.bank = false;
    $scope.card = true;

    $http({
        method: 'GET',
        url: '/onlinebooking/GetBookigByOrderID/',
        params: { OrderID: $routeParams.OrderID, GymID: params.GymID, NameSpace: params.NameSpace }
    }).then(function (data) {
        $scope.backInfo = data.data;

        $scope.backInfo.DateEnd = moment($scope.backInfo.DateEnd).format($scope.dateTimeFormat);
        $scope.backInfo.DateStart = moment($scope.backInfo.DateStart).format($scope.dateTimeFormat);

        $scope.backInfo.Schedules = data.data.Schedules;
        for (var key in $scope.backInfo.Schedules) {
            $scope.backInfo.Schedules[key].DateEnd = moment($scope.backInfo.Schedules[key].DateEnd).format($scope.dateTimeFormat);
        }

        $scope.backInfo.TotalPriceWithoutTax = $routeParams.tpwot;
        if ($scope.backInfo.IsBirthday) {
            $scope.backInfo.visit = 'Birthday Booking';
            $scope.backInfo.Tax = $scope.backInfo.TotalPriceWithProducts - $scope.backInfo.TotalPriceWithoutTax;
        }
        else {
            $scope.backInfo.visit = 'Session Booking';
            $scope.visits = true;
            $scope.backInfo.Tax = $scope.backInfo.TotalPrice - $scope.backInfo.TotalPriceWithoutTax;
        }

        $scope.backInfo.type = 'Card';
    });

}]);


app.controller('GiftCardController', ['$scope', '$http', '$routeParams', '$translate', '$window', '$timeout', function ($scope, $http, $routeParams, $translate, $window, $timeout) {
    $scope.Language = infoData.Country;
    $scope.info = infoData;
    // $scope.info.StripePublishKey = 'pk_test_gfgN1HoPs1PhcySxOdvZ8EOW';
    $scope.vouchers = vouchers;
    $scope.cartArray = [];
    $scope.cartFormArray = [];
    $scope.totalPrice = 0; 
    var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    currentYear += 20;
    $scope.currentStep = 1;
    $scope.success = false;
    $scope.beyondTheOcean = false;

    $scope.Language = infoData.Country;
    
    if (gym) {
		$scope.gym = gym;
		$($scope.gym[0].BODYPart).prependTo('.body-scripts');
        $($scope.gym[0].HEADPart).appendTo(document.head);
    }

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('esm') > -1 || $scope.Language.indexOf('esn') > -1) {
        $translate.use('es')
    }else if($scope.Language.indexOf('cat') > -1){
        $translate.use('esc')
    }
    else if($scope.Language.indexOf('mex') > -1){
        $translate.use('esm')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    if ($scope.Language.indexOf('ena') > -1 || $scope.Language.indexOf('enu') > -1) {
        $scope.beyondTheOcean = true;
    }


    $scope.text = 'me@example.com';
    $scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    $scope.years = [];
    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }


    $scope.changeStep = function (n) {
        if ($scope.success == true) {
            location.reload();
            $scope.success = false;
        }

        $scope.currentStep = n;
    }

    $scope.getCards = function (id) {
        $('.vouchers .voucher[data-voucherId="' + id + '"]').addClass('active');
    }

    $scope.increase = function (item) {
        item.quantity = parseInt(item.quantity);
        item.quantity = item.quantity + 1;
    }
    $scope.decrease = function (item) {
        item.quantity = parseInt(item.quantity);
        if (item.quantity > 1) {
            item.quantity = item.quantity - 1;
        }
    }

    $scope.addToCard = function (id, quantity) {
        var id = id;
        var demoresult = $.grep($scope.cartArray, function (e) { return e.VoucherID == id; });

        if (demoresult.length != 0) {
            $scope.removeByAttr($scope.cartArray, 'VoucherID', id);
            $scope.removeByAttr($scope.cartFormArray, 'VoucherID', id);
        }

        var result = $.grep($scope.vouchers, function (e) { return e.VoucherID == id; });
        result[0].Quantity = quantity;
        result[0].TotalPrice = quantity * result[0].Price;
        $scope.cartArray.push(result[0]);

        for (var i = 0; i < quantity; i++) {
            var giftCardItem = { VoucherID: result[0].VoucherID, VoucherInnerID: result[0].VoucherID + '100' + i, ToFirstName: '', ToLastName: '', ToEmail: '', SendToEmail: false, Name: result[0].Name, Price: result[0].Price };
            $scope.cartFormArray.push(giftCardItem);
        }

        $('.giftcardForm .box-actions').removeClass('disabled-button');

        $scope.makeTotal();
    }

    $scope.makeTotal = function () {
        $scope.totalPrice = 0;
        if ($scope.cartArray.length > 0) {
            for (var i = 0; i < $scope.cartArray.length; i++) {
                $scope.totalPrice += $scope.cartArray[i].TotalPrice;
            }
        }
    }

    $scope.deleteCartItem = function (id) {
        $scope.removeByAttr($scope.cartArray, 'VoucherID', id);
        $scope.removeByAttr($scope.cartFormArray, 'VoucherID', id);
        // $('.vouchers .voucher[data-voucherId="' + id + '"]').find('.qunatity-box input').value('1');
        $('.vouchers .voucher[data-voucherId="' + id + '"]').removeClass('active');
        $scope.makeTotal();

        if ($scope.cartArray.length < 1) {
            $('.giftcardForm .box-actions').addClass('disabled-button');

            if ($scope.currentStep == 2 || $scope.currentStep == 3) {
                $scope.changeStep(1);
            }
        }
    }

    $scope.deleteSingleCartItem = function (id, innerId) {
        var quantity = $.grep($scope.cartArray, function (e) { return e.VoucherID == id; });

        if ($scope.cartFormArray.length == 1) {
            $scope.changeStep(1);
            $('.giftcardForm .box-actions').addClass('disabled-button');
        }

        if (quantity[0].Quantity == 1) {
            $scope.removeByAttr($scope.cartArray, 'VoucherID', id);
            $scope.removeByAttr($scope.cartFormArray, 'VoucherID', id);
        } else {
            quantity[0].Quantity = quantity[0].Quantity - 1;
            quantity[0].TotalPrice = quantity[0].Quantity * quantity[0].Price;
            $scope.removeByAttr($scope.cartFormArray, 'VoucherInnerID', innerId);
        }


        $scope.makeTotal();
    }

    $scope.placeOrder = function (token) {
        if ( $scope.loading != true ) {
            $scope.loading = true;
            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');

            if ($scope.paymentType == 7) {
                $scope.paymentTypeProvider = "paylogin";
            }
            if ($scope.paymentType == 8) {
                $scope.paymentType = 7;
                $scope.paymentTypeProvider = "credit_paydirect";
            }
            var dateObjectOrder = { FromFirstName: $scope.fromFirstName, FromLastName: $scope.fromLastName, FromTelephone: $scope.fromTelephone, FromEmail: $scope.fromEmail, PaymentType: $scope.paymentType, Token: token, GiftCards: $scope.cartFormArray, Namespace: infoData.NameSpace, GymID: infoData.GymID, ZIP: $scope.zip, Token: token, PaymentProvider: $scope.paymentTypeProvider }

            $http({
                method: 'POST',
                url: '/GiftCard/Buy',
                data: dateObjectOrder,
                dataType: 'json',
                headers: {
                    "Content-Type": "application/json"
                }
            }).success(function (data) {

                if ((data.Error != undefined && data.Error != '') || data == "Error" || data == "False") {
                    $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                    if (data.Error != undefined)
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + data.Error + '</div>');
                    else
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">There was a problem while processing the credit card! Please check all fields and credit card funds!</div>');

                    $('.steps-body .step-actions button.pay').removeClass('disabled');
                    $scope.loading = false;
                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                    $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                } else {
                    if ($scope.paymentType == "1" || $scope.paymentType == "5" || $scope.paymentType == "7" || $scope.paymentType == "8") {
                        window.location.href = data;
                    }
                    else {
                        $scope.finalVouchers = data.GiftCards;
                        $scope.success = true;

                        $('.steps-body .step-actions button.pay').removeClass('disabled');
                        $scope.loading = false;
                        $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                        $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                    }
                }
            }).error(function () {
                $('.steps-body .step-actions button.pay').removeClass('disabled');
                $scope.loading = false;
                $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
            });
        }
    }

    $scope.$watch('paymentType', function (v) {
        $scope.paymentType = v;

        if (v == 4) {
            if (!$scope.paySafeInit) {
                if ($scope.info.PaySafeCard == true && $scope.info.PaySafeApiKeyFrontEnd != '') {
                    $scope.paySafeInit = true;
                    // Base64 encoded version the Single-use Token API key.
                    // Create the key below by concatenating the API username and password
                    // separated by a colon and Base64-encoding the result
                    var apiKey = $scope.info.PaySafeApiKeyFrontEnd;
                    var Enviroment = "TEST";
                    if ($scope.Enviroment == true)
                        Enviroment = "LIVE";
                    var options = {

                        // select the Paysafe test / sandbox environment
                        environment: Enviroment,

                        // set the CSS selectors to identify the payment field divs above
                        // set the placeholder text to display in these fields
                        fields: {
                            cardNumber: {
                                selector: "#cardNumber",
                                placeholder: "Card number"
                            },
                            expiryDate: {
                                selector: "#expiryDate",
                                placeholder: "Expiry date"
                            },
                            cvv: {
                                selector: "#cvv",
                                placeholder: "CVV"
                            }
                        }
                    };

                    paysafe.fields.setup(apiKey, options, function (instance, error) {
                        document.getElementById("payNow").addEventListener("click", function (event) {
                            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');
                            instance.tokenize(function (instance, error, result) {
                                if (error) {
                                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                                    $('.payment-status .error-msg').addClass('show').append('<p>' + error.message + '</p>');
                                } else {
                                    $scope.placeOrder(result.token);
                                }
                            });
                        }, false);
                    });
                }
            }
        }
        else {
            $scope.ShowPaySafe = false;
        }

        if (v == 66) {
            let price =  $scope.totalPrice;
            let finalBankPrice;
            finalBankPrice = price.toFixed(2).split('.').join("");
            finalBankPrice = parseInt(finalBankPrice);

            var hostedPayments = SimplifyCommerce.hostedPayments(
                function(response) {
                    var cardToken = response.cardToken;
                    // TODO: Pass token to the server & use Simplify's API to make a payment
                    $scope.placeOrder(cardToken);
                },
                {
                    scKey: infoData.CommBankPublicApiKey,
                    amount: finalBankPrice,
                    operation: 'create.token',
                    name: infoData.SubscriptionName,
                    description: ''

                }
            ).closeOnCompletion();
            /**
             * Handle the error response from the server call that
             * failed to make a payment from the card token.
             */
            function apiPaymentErrorHandler() {
                // re-enable the payment button, so the user can try again.
                hostedPayments.enablePayBtn();
                // TODO: Handle error
            }

            $("#process-payment-hp").on("click", function () {
                $(".giftcard-wrapper .payment-form .form-head .rb-commbankhp button").trigger('click');
            })
        }

        if (v == 6) {
            $("#process-payment-btn").on("click", function () {
                $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');
                $('.payment-form.cbform, .loader-container.cbform-loader').addClass('loading');
                // Generate a card token & handle the response
                SimplifyCommerce.generateToken({
                    key: infoData.CommBankPublicApiKey,
                    card: {
                        number: $("#cc-number").val(),
                        cvc: $("#cc-cvc").val(),
                        expMonth: $("#cc-exp-month").val(),
                        expYear: $("#cc-exp-year").val()
                    }
                }, simplifyResponseHandler);
                // Prevent the form from submitting
                return false;
            });

            function simplifyResponseHandler(data) {
                var $paymentForm = $("#payment-form");
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // console.log(errorList);
                        // Display the errors
                        $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');

                        $('.steps-body .step-actions button.pay').removeClass('disabled');
                        $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                    }
                    // Re-enable the submit button
                    $scope.loading = false;
                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                    $("#process-payment-btn").removeAttr("disabled");
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form.cbform .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server

                    $scope.placeOrder(token);
                    // $paymentForm.get(0).submit();
                }
            }
        }

        if (v == 9) {
            $('#stripe-button').addClass('show');
            // Create a Stripe client.
            var stripe = Stripe($scope.info.StripePublishKey);
            // Create an instance of Elements.
            var elements = stripe.elements();
            // Custom styling can be passed to options when creating an Element.
            // (Note that this demo uses a wider set of styles than the guide below.)
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };


            // Create an instance of the card Element.
            if ($scope.currencyCode == 'EUR') {
                var card = elements.create('card', { style: style, hidePostalCode: true });
            } else {
                var card = elements.create('card', { style: style });
            }

            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.on('change', function(event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            // Handle form submission.
            var form = document.getElementById('payment-form');

            $('#stripe-button').on('click', function (e) {
                $scope.orderLoading = true;
                e.preventDefault();

                stripe.createToken(card).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        $scope.orderLoading = false;
                    } else {
                        // Send the token to your server.
                        $scope.placeOrder(result.token.id);
                    }
                });

            })
        } else {
            $('#stripe-button').removeClass('show');
        }

    });

    $('.giftcard-wrapper .box-head i').on('click', function () {
        $('.giftcard-wrapper').toggleClass('show-cart');
    });

    $('.menu-trigger').on('click', function (e) {
        e.preventDefault();
        $('.header').toggleClass('show-menu');
    });

    $(window).on('load', function(){
        if (giftCard) {
            $timeout(() => {
                $scope.getCards(giftCard);
                $scope.giftCard = giftCard;
            })
        }
    })


    // $scope.activeStep = function(n){
    //     $('.step').eq(n).addClass('active');

    //     return false;
    // }

}]);

app.controller('GiftCardStatusController', ['$scope', '$http', '$routeParams', '$translate', '$window', function ($scope, $http, $routeParams, $translate, $window) {
    $scope.order = order;
    $scope.info = infoData;

    $scope.hrefStart = window.location.origin + '/giftcard/index?GymID=' + infoData.GymID + '&NameSpace=' + infoData.NameSpace;

    $scope.Language = infoData.Country;

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }
    else if ($scope.Language.indexOf('esm') > -1 || $scope.Language.indexOf('esn') > -1) {
        $translate.use('es')
    }else if($scope.Language.indexOf('cat') > -1){
        $translate.use('esc')
    }
    else if($scope.Language.indexOf('mex') > -1){
        $translate.use('esm')
    }
    else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }
    else {
        $translate.use('en')
    }

    if ($scope.Language.indexOf('ena') > -1 || $scope.Language.indexOf('enu') > -1) {
        $scope.beyondTheOcean = true;
    }


}]);